var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BaseTag base-tag",class:{'is--round': _vm.round, 'is--white-text': _vm.whiteTextColor, 'is--strong-text': _vm.strongText, 'is--icon': _vm.icon,},style:({ background: _vm.background })},[_c('div',{staticClass:"base-tag__icon-wrapper"},[_vm._t("icon")],2),_c('p',{staticClass:"base-tag__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }